<template>
  <div>
    <breadcrumbs :crumbs="[{name:'Administrative Settings'},{name:'Form List', link:'Form Builder Index'}]"/>
    <div class="row">
      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title tabbable-line">
            <div class="caption caption-md">
              <i class="icon-settings font-dark"></i>
              <span class="caption-subject font-dark sbold uppercase">Form list</span>
            </div>

            <ul v-if="!isChildAccount" class="nav nav-tabs">
              <li v-for="tab in tabs"
                  :key="tab.id"
                  :class="{active: activeTab === tab.id}"
                  @click="setActiveTab(tab.id)">
                <a :href="`#${tab.id}`"
                   data-toggle="tab"
                   aria-expanded="false">
                  {{ tab.label }}
                </a>
              </li>
            </ul>
          </div>

          <p v-if="isChildAccount">Changes to forms must be completed from Parent Account:
            <strong>
              <a v-if="appUser.access > 5" :href="this.$router.resolve({name:'Manage Account Edit CaseMGR', params: {casemgrid: parentAccount.id}}).href">{{parentAccount.name}}</a>
              <span v-else>{{parentAccount.name}}</span>
            </strong>
          </p>

          <div v-if="!isChildAccount" class="tab-content marginTop">
            <div v-for="tab in tabs"
                 class="tab-pane"
                 :class="{active: activeTab === tab.id}"
                 :id="tab.id">
              <component v-if="activeTab === tab.id"
                         :is="tab.component"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapGetters} from "vuex";
  import SystemFormsIndex from "../components/formbuilder/indexes/SystemFormsIndex";
  import ParticipantFormsIndex from "../components/formbuilder/indexes/ParticipantFormsIndex";
  import OrganizationFormsIndex from "../components/formbuilder/indexes/OrganizationFormsIndex";
  import ReferralFormsIndex from "../components/formbuilder/indexes/ReferralFormsIndex";
  import TemplatesIndex from "../components/formbuilder/indexes/TemplatesIndex";
  import FieldTemplatesIndex from "../components/formbuilder/indexes/FieldTemplatesIndex";
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],

    components: {
      SystemFormsIndex,
      ParticipantFormsIndex,
      OrganizationFormsIndex,
      ReferralFormsIndex,
      TemplatesIndex,
      FieldTemplatesIndex,
      Breadcrumbs
    },

    data() {
      return {
        activeTab: 'system-forms',
      }
    },

    computed: {
      ...mapGetters({
        appUser: 'getUser'
      }),
      tabs () {
        return [{
          id: 'system-forms',
          label: 'System Forms',
          component: SystemFormsIndex,
        }, {
          id: 'participant-forms',
          label: `${this.participantSingularName} Forms`,
          component: ParticipantFormsIndex,
        }, {
          id: 'organization-forms',
          label: 'Organization Forms',
          component: OrganizationFormsIndex,
        }, {
          id: 'referral-forms',
          label: 'Referral Forms',
          component: ReferralFormsIndex,
        }, {
          id: 'templates',
          label: 'Templates',
          component: TemplatesIndex,
        }, {
          id: 'field-templates',
          label: 'Field Templates',
          component: FieldTemplatesIndex,
        }]
      },
      isChildAccount() {
        return this.appUser.organizations[0].accountType === 'child'
      },
      parentAccount() {
        if (this.isChildAccount) {
          return this.appUser.organizations[0].parentAccount;
        }
      }
    },

    methods: {
      setActiveTab(activeTabTitle) {
        this.activeTab = activeTabTitle;
      }
    },

    inject: {
      $validator: '$validator'
    }
  }
</script>

<style>
  .vgt-table .last-dropdown {
    width: auto;
  }

  .vgt-table .dropdown-menu {
    left: -110px;
  }

  .vgt-table .dropdown > .dropdown-menu:before,
  .vgt-table .dropdown-toggle > .dropdown-menu:before,
  .vgt-table .btn-group > .dropdown-menu:before {
    left: 140px;
  }

  .vgt-table .btn-group > .dropdown-menu:after {
    left: 141px;
  }
</style>



// WEBPACK FOOTER //
// FormBuilderIndex.vue?10cdeee0